import { Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const expertisePanels = [{
  id: "01",
  title: "Weddings & Galas",
  items: ["Luxury Lighting Design", "Crystal Clear Audio", "Bespoke Stage Sets"],
  accent: "text-secondary"
}, {
  id: "02",
  title: "Corporate & Live",
  items: ["LED Video Walls", "Live Stream Solutions", "Conference PA Systems"],
  accent: "text-primary"
}, {
  id: "03",
  title: "PulseFX Special Effects",
  items: ["Cold Spark Pyrotechnics", "Dry Ice & CO2 Jets", "Confetti & Laser Shows"],
  accent: "text-secondary"
}];
export default function OurExpertise() {
  return <section className="py-16 px-4 bg-background" id="expertise">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {expertisePanels.map((panel, i) => <Card key={panel.id} data-index={i} className="relative overflow-hidden border-white/10 bg-card/40 backdrop-blur-xl transition-all duration-300 hover:scale-[1.02] hover:border-primary/50 group">
              <CardHeader className="pt-12 pb-6">
                
                <CardTitle className={`text-2xl font-bold tracking-tighter ${panel.accent}`}>
                  {panel.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-4">
                  {panel.items.map((item, itemIdx) => <li key={itemIdx} className="flex items-center gap-3 text-foreground/80 group-hover:text-foreground transition-colors">
                      <Check className={`h-5 w-5 shrink-0 ${panel.accent}`} />
                      <span className="text-lg font-medium leading-tight">{item}</span>
                    </li>)}
                </ul>
              </CardContent>
              {}
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </Card>)}
        </div>
      </div>
    </section>;
}